export const MAZE_BLUEPRINT: ReadonlyArray<ReadonlyArray<readonly [number, number]>> = [
  [[22, 5], [24, 7], [19, 8], [21, 8], [20, 4]],
  [[7, 8], [5, 6], [7, 4], [9, 7], [11, 5]],
  [[7, 2], [13, 3], [15, 5], [17, 6], [23, 9]],
  [[26, 5], [28, 3], [30, 4], [32, 3], [34, 5]],
  [[36, 7], [37, 9], [35, 11], [34, 13], [32, 15]],
  [[33, 10], [30, 17], [28, 19], [26, 21], [24, 23]],
  [[22, 25], [20, 27], [22, 29], [24, 31], [26, 33]],
  [[24, 35], [22, 37], [20, 36], [18, 34], [16, 33]],
  [[14, 31], [12, 29], [10, 28], [8, 26], [6, 24]],
  [[4, 22], [6, 20], [8, 18], [10, 16], [3, 20]],
  [[12, 14], [14, 12], [15, 10], [14, 8], [17, 12]],
  [[19, 12], [21, 12], [23, 14], [25, 16], [27, 16]],
  [[29, 14], [18, 3], [30, 12], [24, 11], [26, 13]],
  [[28, 10], [27, 8], [32, 8], [25, 16], [29, 14]],
  [[21, 32], [18, 29], [16, 27], [14, 25], [12, 23]],
  [[25, 18], [10, 21], [11, 19], [13, 17], [23, 20]],
  [[15, 15], [21, 22], [19, 24], [17, 15], [19, 16]],
  [[21, 17], [17, 24], [15, 22], [14, 20], [16, 18]],
  [[20, 19], [18, 21], [14, 12], [12, 12], [6, 22]],
  [[7, 24], [7, 16], [11, 19], [24, 18], [27, 16]],
  [[7, 24], [24, 18], [12, 30], [25, 16], [7, 30]],
  [[25, 11], [22, 34], [15, 35], [30, 19], [12, 25]],
  [[26, 23], [28, 21], [28, 23], [30, 23], [32, 24]],
  [[34, 22], [36, 20], [34, 18], [36, 16], [33, 20]],
  [[37, 14], [14, 26], [5, 14], [34, 26], [36, 28]],
  [[25, 11], [10, 28], [6, 28], [15, 10], [4, 28]],
  [[2, 8], [4, 9], [6, 11], [3, 12], [3, 14]],
  [[13, 34], [23, 9], [10, 29], [9, 31], [17, 36]],
  [[28, 35], [30, 35], [32, 37], [34, 35], [36, 36]],
  [[38, 32], [36, 31], [34, 31], [33, 29], [31, 27]],
  [[29, 26], [27, 27], [25, 27], [12, 30], [14, 12]],
  [[22, 27], [12, 30], [32, 35], [15, 10], [18, 27]],
  [[27, 29], [34, 24], [26, 35], [30, 37], [12, 32]],
  [[24, 33], [20, 28], [20, 30], [26, 3], [36, 26]],
  [[13, 10], [18, 27], [25, 16], [7, 32], [28, 37]],
  [[21, 13], [26, 13], [13, 8], [4, 36], [5, 34]],
  [[19, 16], [15, 3], [22, 3], [24, 3], [15, 37]],
  [[18, 21], [5, 4], [36, 18], [3, 5], [37, 11]],
  [[15, 10], [14, 12], [21, 12], [23, 14], [26, 13]],
  [[13, 37], [8, 36], [11, 36], [13, 10], [8, 38]],
  [[14, 20], [5, 2], [3, 3], [9, 2], [9, 9]],
  [[11, 23], [13, 5], [2, 17], [8, 12], [4, 17]],
  [[19, 19], [24, 5], [2, 25], [4, 25], [2, 31]],
  [[19, 24], [22, 20], [28, 5], [2, 33], [4, 31]],
  [[15, 22], [14, 12], [8, 28], [18, 27], [29, 28]],
  [[16, 18], [23, 14], [14, 12], [18, 27], [10, 33]],
  [[17, 24], [25, 16], [23, 14], [11, 19], [14, 12]],
  [[13, 8], [14, 12], [17, 15], [29, 8], [34, 8]],
  [[9, 7], [34, 3], [36, 3], [36, 5], [36, 22]],
  [[12, 12], [29, 30], [31, 29], [36, 24], [24, 37]],
];

export const MAZE_REMOVALS: ReadonlyArray<ReadonlyArray<readonly [number, number]>> = [
  [],
  [],
  [],
  [],
  [],
  [],
  [],
  [],
  [],
  [],
  [],
  [],
  [],
  [[25, 16], [29, 14]],
  [],
  [],
  [],
  [],
  [[14, 12]],
  [[27, 16], [25, 18], [11, 19], [6, 24]],
  [[12, 29], [25, 16], [24, 18], [7, 24]],
  [[24, 11], [12, 25]],
  [],
  [],
  [[14, 25]],
  [[25, 11], [10, 28], [15, 10], [7, 28]],
  [],
  [[23, 9], [10, 28]],
  [],
  [],
  [[11, 32], [14, 12], [12, 30]],
  [[15, 10], [12, 30]],
  [[12, 32]],
  [[20, 27]],
  [[25, 16], [18, 27], [13, 10]],
  [[14, 12], [26, 13], [21, 12], [14, 8]],
  [[19, 16]],
  [[18, 21]],
  [[23, 14], [15, 10], [21, 13], [26, 13], [13, 10]],
  [[15, 10]],
  [[14, 20]],
  [[12, 23]],
  [[20, 19], [15, 10]],
  [[19, 24], [23, 20]],
  [[15, 22], [14, 12], [18, 27]],
  [[16, 18], [14, 12], [18, 27], [23, 14]],
  [[17, 24], [15, 10], [23, 14], [14, 12], [11, 19], [25, 16]],
  [[17, 15], [13, 8], [15, 12], [14, 12]],
  [[9, 7]],
  [[12, 12]],
];

export const MAZE_KEEPER_INDICES: ReadonlyArray<number> = [3, 0, 1, 2, 4, 4, 4, 4, 3, 1, 4, 0, 1, 2, 2, 1, 0, 0, 4, 1, 4, 2, 2, 0, 4, 0, 0, 0, 2, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0];
